import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgSavedItem(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.9 60.063c-2.444-9.157 2.97-18.57 12.092-21.023L89.56 22.75l14.754 55.268L27.227 98.75 16.9 60.063Z"
        fill="#F1F5F9"
      />
      <path
        d="M73.313 60.75c0 7.732-6.492 14-14.5 14s-14.5-6.268-14.5-14 6.492-14 14.5-14 14.5 6.268 14.5 14Z"
        fill="#78B441"
      />
      <path
        d="M63.439 56.788a1.3 1.3 0 0 1 1.748 1.924l-6.6 6a1.3 1.3 0 0 1-1.749 0l-4.399-4a1.3 1.3 0 1 1 1.748-1.924l3.525 3.204 5.727-5.204Z"
        fill="#fff"
      />
      <path
        d="m59.566 34.579-1.675 2.931c-.433.759.412 1.605 1.17 1.17l2.932-1.674-2.427-2.427Z"
        fill="#B3C0D0"
      />
      <path
        d="m58.764 40.71-2.901-2.901a.8.8 0 1 1 1.13-1.132l2.902 2.901a.8.8 0 1 1-1.131 1.131Z"
        fill="#232323"
      />
      <path
        d="M72.308 29.927c.601-1.41.553-3.088-1.01-4.652-1.565-1.564-3.243-1.612-4.653-1.011-1.41.6-5.606 3.178-7.281 4.854-1.676 1.675-1.223 4.845 1.011 7.079s5.404 2.687 7.08 1.011c1.675-1.675 4.253-5.871 4.853-7.281Z"
        fill="#007A5F"
      />
      <path
        d="M72.51 24.061c2.235 2.234 2.688 5.404 1.012 7.08-1.675 1.675-4.845 1.222-7.079-1.012s-2.687-5.404-1.011-7.08c1.675-1.675 4.845-1.222 7.079 1.012Z"
        fill="#00664F"
      />
      <path
        d="M72.087 24.485c-1.034-1.034-2.27-1.64-3.41-1.802-1.14-.163-2.147.116-2.821.79-.674.675-.954 1.682-.791 2.822.163 1.14.768 2.376 1.802 3.41 1.034 1.034 2.27 1.64 3.41 1.802 1.14.163 2.147-.117 2.821-.791l.424.424-.16.151c-1.712 1.495-4.755 1.002-6.919-1.162-2.234-2.234-2.686-5.404-1.011-7.08l.162-.15c1.711-1.494 4.753-1.002 6.917 1.162 2.234 2.234 2.687 5.403 1.011 7.079l-.424-.424c.674-.675.954-1.68.791-2.821-.163-1.14-.768-2.376-1.802-3.41Z"
        fill="#00664F"
      />
      <path
        d="M72.511 24.061c1.787 1.787 2.15 4.323.81 5.663-1.341 1.34-3.877.979-5.664-.809-1.788-1.787-2.15-4.322-.81-5.663 1.341-1.34 3.877-.978 5.664.81Z"
        fill="#007A5F"
      />
      <path
        d="M96.524 65.472a.8.8 0 0 1 1.578.265l-1.704 10.146a.8.8 0 0 1-1.578-.266l1.704-10.145ZM29.736 44.424a.8.8 0 0 1 1.46.652c-.49 1.1-.795 2.338-.98 3.99a.8.8 0 0 1-.602.688c-3.692.916-6.195 3.497-7.598 6.086a.8.8 0 1 1-1.406-.762c1.49-2.751 4.143-5.573 8.083-6.731.203-1.512.525-2.763 1.043-3.923Z"
        fill="#B3C0D0"
      />
    </svg>
  )
}
export default wrapIllustration(SvgSavedItem)
